export default __webpack_public_path__ + "static/media/icon_rotation_stop.18b176a7.svg";